import { Box, Typography } from "@mui/material";

export function EnvironmentBadge() {
  const env = process.env.REACT_APP_ENVIRONMENT || "dev";
  if (env === "prod") {
    return null;
  }

  let bgColor: string;
  let label: string;

  if (env === "beta") {
    bgColor = "red";
    label = "Beta";
  } else {
    bgColor = "blue";
    label = "Development";
  }

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        backgroundColor: bgColor,
        color: "white",
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        textAlign: "center",
        fontSize: "0.75rem",
        mt: 0.5,
        mb: 3,
        lineHeight: 1,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: "bold", lineHeight: 1 }}>
        {label}
      </Typography>
    </Box>
  );
}
